import { FC, useState } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { Button, IconButton, Link } from '@mui/material';
import Container from '@mui/material/Container';

import DownloadAndroidApkIcon from 'components/common/icons/DownloadAndroidApk';

import SocialBox from './SocialBox';
import TermsAndConditionsModal from './TermsAndConditionsModal';

type FooterProps = {
  bgColor?: string;
  email: string;
  fontColor: string;
  termsAndConditions: string;
  downloadApkUrl?: string;
};

const Footer: FC<FooterProps> = ({ bgColor, email, fontColor, termsAndConditions, downloadApkUrl }) => {
  const [isTermsAndConditionsModalOpen, setIUsTermsAndConditionsModalOpen] = useState(false);

  const downloadUrl = downloadApkUrl && `https://${downloadApkUrl}`;

  return (
    <Box
      component="footer"
      sx={{ bgcolor: bgColor || 'custom.common.black', color: 'custom.common.white', borderRadius: 0 }}
    >
      <Container>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
          py={2}
        >
          <SocialBox />
          <Link href={`mailto:${email}`} sx={{ color: fontColor || 'custom.common.white' }}>
            {email}
          </Link>
          <Button
            onClick={(): void => setIUsTermsAndConditionsModalOpen(true)}
            sx={{ color: fontColor || 'custom.common.white' }}
          >
            Terms and Conditions
          </Button>
          {downloadUrl && (
            <a href={downloadUrl} download={downloadUrl} rel="noopener noreferrer">
              <IconButton style={{ height: 60, width: 35 }}>
                <DownloadAndroidApkIcon />
              </IconButton>
            </a>
          )}
        </Stack>
      </Container>
      {isTermsAndConditionsModalOpen && (
        <TermsAndConditionsModal
          bgColor={bgColor}
          termsAndConditions={termsAndConditions}
          fontColor={fontColor}
          onClose={(): void => setIUsTermsAndConditionsModalOpen(false)}
        />
      )}
    </Box>
  );
};

export default Footer;
